/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const ThuIcon = createIcon({
  displayName: "ThuIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M4.33887 4.77291V3.54492H11.656V4.77291H8.70605V12.9995H7.28418V4.77291H4.33887Z"
        fill="currentColor"
      />
    </g>
  )
});
